import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { login, logout } from '../../redux/auth'
import { forgottenUser } from '../../redux/user';
import {
  showSignIn, 
  hideSignIn,
  showForgotten,
  hideForgotten } from '../../redux/modals'

import SignInModal from '../SignInModal';
import ForgottenModal from '../ForgottenModal';
import './Navigation.css';

class Navigation extends React.Component {
  static propTypes = {
    history: PropTypes.shape().isRequired,
    onLogout: PropTypes.func.isRequired, 
    isAuthenticated: PropTypes.bool.isRequired, 
  }

  render() {
    const { 
      isAuthenticated, 
      history,
      onSubmitLogin, 
      showSignIn, 
      onHideSignIn,
      onSubmitForgotten,
      showForgotten,
      onShowForgotten,
      onHideForgotten,
      forgottenError,
      onLogout } = this.props;
    
    const buttons = isAuthenticated ? 
      [
        { label: 'Buy Now', onClick: () => history.push('/development'), className: 'buy-now' },
        { label: 'Profile', onClick: () => history.push('/profile'), },
        { label: 'Log Out', onClick: onLogout },
      ] :
      [
        { label: 'Buy Now', onClick: () => history.push('/development'), className: 'buy-now' },
        { label: 'Register', onClick: () => history.push('/register'), },
        { label: 'Sign In', onClick: this.props.onShowSignIn },
      ];
    
    return (
      <div className="navigation">
        { buttons.map((detail, idx) => (<button key={idx} onClick={detail.onClick} className={detail.className || ''}>{detail.label}</button>)) }
        <SignInModal
          isOpen={showSignIn}
          onSubmit={onSubmitLogin}
          onClose={onHideSignIn}
          onForgotten={onShowForgotten}
        />
        <ForgottenModal
          isOpen={showForgotten}
          onSubmit={onSubmitForgotten}
          onClose={onHideForgotten}
          error={forgottenError}
        />
      </div>
    );
  }
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  showSignIn: state.modals.showSignIn,
  showForgotten: state.modals.showForgotten,
})

const mapDispatchToProps = (dispatch, props) => ({
  onSubmitLogin: ({ email, password }) => dispatch(login({ email, password })),
  onShowSignIn: () => dispatch(showSignIn()),
  onHideSignIn: () => dispatch(hideSignIn()),
  onSubmitForgotten: ({ email }) => dispatch(forgottenUser(email)),
  onShowForgotten: () => dispatch(showForgotten()),
  onHideForgotten: () => dispatch(hideForgotten()),
  onLogout: () => dispatch(logout()),
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation))



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx